import { render, staticRenderFns } from "./mainSafetyHealthyMst.vue?vue&type=template&id=3db7838a"
import script from "./mainSafetyHealthyMst.vue?vue&type=script&lang=js"
export * from "./mainSafetyHealthyMst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3db7838a')) {
      api.createRecord('3db7838a', component.options)
    } else {
      api.reload('3db7838a', component.options)
    }
    module.hot.accept("./mainSafetyHealthyMst.vue?vue&type=template&id=3db7838a", function () {
      api.rerender('3db7838a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/main/mainSafetyHealthyMst.vue"
export default component.exports